<template>
	<div class="refundOrder-body">
		<!-- <div class="shop-position">
			<img src="~/images/icon/position-icon.png">
			当前卖家店铺：
			<el-select size="mini" v-model="sellerShopId" placeholder="请选择" @change="shopChange">
				<el-option
				v-for="item in shopOptions"
				:key="item.shopId"
				:label="item.shopName"
				:value="item.shopId"/>
			</el-select>
		</div> -->
		<ul class="refundOrder-menu">
			<li
				v-for="item in refundOrderMenu"
				:key="item.name"
				v-show='item.show'
				:class="{ active : active === item.name }"
				@click="refundOrderMenuSwitch(item)"
			>{{item.name}}</li>
			<div class="menu-right">
				<el-button size="small" type="primary" plain class="btn fx-btn export-btn" style="margin-left: 10px" @click="exportExcel">
					<div></div>
					导出
				</el-button>
			</div>
		</ul>
		<Search :active="active" :customList="customList" :overrefunddock='overrefunddock' :clddock="clddock" :origin="origin" ref='searchRef' @handleSearch="handleSearch"/>
		<MainTable
			:clddock="clddock"
			:overrefunddock='overrefunddock'
			:totalCount='totalCount'
			:active='active'
			:orderSort='orderSort'
			:size='size'
			:page='page'
			:tableData='tableData'
			@saveSelect='saveSelect'
			@sortList='sortList'
			@handleSize='handleSizeChange'
			@tableReload='tableReload'
			@handlePage='handlePageChange'
		/>
	</div>
</template>

<script>
import Search from '@/views/index/src/refundorderDock/Search.vue'
import MainTable from '@/views/index/src/refundorderDock/MainTable.vue'
export default {
	name: 'refundOrder',
	components: {
		Search,
		MainTable
	},
	data () {
		return {
			shopOptions: [],
			sellerShopId: '',
			refundOrderMenu: [
				{ name: '全部退单', show: true },
				{ name: '待处理', orderStatus: '0', show: false },
				{ name: '已同意', orderStatus: '1', show: false },
				{ name: '已拒绝', orderStatus: '2', show: false },
				{ name: '退货完成', orderStatus: '3', show: false }
			],
			active: '全部退单',
			dateValue: [],
			buyerTel: '',
			refundOrderNumber: '',
			orderNumber: '',
			paymentMode: '-1',
			payStatus: -1,
			liquidateflag: '-1',
			pushstate: -1,
			buyerName: '',
			orderStatus: 0,
			page: 1,
			size: 20,
			tableData: [],
			refundNumber: '',
			cause: -1,
			totalCount: 0,
			clddock: 0,
			overrefunddock: 0,
			origin: '',
			excelParams: {},
			customList: [],
			customerCategoryId: '0',
			customerName: '',
			sourcetype: -1,
			autorefundflag: -1,
			address: '',
			orderSort: ''
		}
	},
	created () {
		this.login().then(res => {
			this.getAuthority('07_0002_0000_00')
			this.getCategory()
			this.openPage()
		})
	},
	methods: {
		login () {
			return new Promise((resolve, reject) => {
				if (!this.$route.query.password) {
					resolve()
					return false
				}
				window.sessionStorage.setItem('password', this.$route.query.password)
				window.sessionStorage.setItem('username', this.$route.query.username)
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/match/returnShiroSession`
				}).then(res => {
					if (res.result) {
						window.sessionStorage.setItem('shiroSession', res.data.shiroSession)
						resolve()
					} else {
						this.$message.error(res.msg)
					}
				}).catch(err => {
					this.$message.error(err.msg)
				})
			})
		},
		openPage () {
			console.log(this.orderNumber)
			if (window.sessionStorage.getItem('refundOrderSelect')) {
				let data = JSON.parse(window.sessionStorage.getItem('refundOrderSelect'))
				this.dateValue = data.dateValue
				this.buyerTel = data.buyerTel
				this.refundOrderNumber = data.refundOrderNumber
				this.orderNumber = data.orderNumber
				this.paymentMode = data.paymentMode
				this.payStatus = data.payStatus
				this.buyerName = data.buyerName
				this.refundNumber = data.refundNumber
				this.cause = data.cause
				this.pushstate = data.pushstate
				this.liquidateflag = data.liquidateflag
				this.customerCategoryId = data.customerCategoryId
				this.customerName = data.customerName
				this.sourcetype = data.sourcetype
				this.autorefundflag = data.autorefundflag
				this.address = data.address
				this.page = data.page
				this.size = data.size
				this.excelParams = {
					beginDate: window.sessionStorage.getItem('startDate') ? window.sessionStorage.getItem('startDate') : data.dateValue.length > 0 ? data.dateValue[0] : this.$fxUtils.getCurrentMonthFirst() + ' 00:00',
					endDate: window.sessionStorage.getItem('endDate') ? window.sessionStorage.getItem('endDate') : data.dateValue.length > 0 ? data.dateValue[1] : this.$fxUtils.getCurrentMonthLast() + ' 23:59',
					orderNumber: data.orderNumber,
					refundNumber: data.refundNumber,
					buyerName: data.buyerName,
					buyerTel: data.buyerTel,
					pushstate: data.pushstate,
					paymentMode: data.paymentMode,
					payStatus: data.payStatus,
					cause: data.cause,
					liquidateflag: data.liquidateflag,
					customerCategoryId: data.customerCategoryId,
					customerName: data.customerName,
					sourcetype: data.sourcetype,
					autorefundflag: data.autorefundflag,
					address: data.address
				}
			} else {
				this.excelParams = {
					beginDate: window.sessionStorage.getItem('startDate') ? window.sessionStorage.getItem('startDate') : this.dateValue.length > 0 ? this.dateValue[0] : this.$fxUtils.getCurrentMonthFirst() + ' 00:00',
					endDate: window.sessionStorage.getItem('endDate') ? window.sessionStorage.getItem('endDate') : this.dateValue.length > 0 ? this.dateValue[1] : this.$fxUtils.getCurrentMonthLast() + ' 23:59',
					orderNumber: this.orderNumber,
					refundNumber: this.refundNumber,
					buyerName: this.buyerName,
					buyerTel: this.buyerTel,
					pushstate: this.pushstate,
					paymentMode: this.paymentMode,
					payStatus: this.payStatus,
					cause: this.cause,
					liquidateflag: this.liquidateflag,
					customerCategoryId: this.customerCategoryId,
					customerName: this.customerName,
					sourcetype: this.sourcetype,
					autorefundflag: this.autorefundflag,
					address: this.address
				}
			}

			let a = JSON.parse(window.sessionStorage.getItem('refundTab'))
			if (a) {
				if (!a.origin) {
					this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59']
				} else {
					this.origin = a.origin
				}
				let c = window.sessionStorage.getItem('startDate')
				let b = window.sessionStorage.getItem('endDate')
				if (c) {
					this.dateValue = [c, b]
				}
				this.findShopList().then((data) => {
					this.shopOptions = data
					this.sellerShopId = a.shopId
					this.active = a.active
					this.orderStatus = a.orderStatus
					this.findrefundOrderList()
				})
			} else {
				this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59']
				let c = window.sessionStorage.getItem('startDate')
				let b = window.sessionStorage.getItem('endDate')
				if (c) {
					this.dateValue = [c, b]
				}
				this.findShopList().then((data) => {
					if (data.length > 0) {
						this.sellerShopId = data[0].shopId
						this.shopOptions = data
						this.findrefundOrderList()
					}
				})
			}
		},
		saveSelect () {
			let params = {
				dateValue: this.dateValue,
				buyerTel: this.buyerTel,
				refundOrderNumber: this.refundOrderNumber,
				orderNumber: this.orderNumber,
				paymentMode: this.paymentMode,
				payStatus: this.payStatus,
				buyerName: this.buyerName,
				refundNumber: this.refundNumber,
				cause: this.cause,
				pushstate: this.pushstate,
				liquidateflag: this.liquidateflag,
				customerCategoryId: this.customerCategoryId,
				customerName: this.customerName,
				sourcetype: this.sourcetype,
				autorefundflag: this.autorefundflag,
				address: this.address,
				page: this.page,
				size: this.size
			}
			window.sessionStorage.setItem('refundOrderSelect', JSON.stringify(params))
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						switch (a[i]) {
						case '07_0002_0001_00':
							this.refundOrderMenu[1].show = true
							break
						case '07_0002_0007_00':
							this.refundOrderMenu[2].show = true
							break
						case '07_0002_0010_00':
							this.refundOrderMenu[3].show = true
							break
						case '07_0002_0013_00':
							this.refundOrderMenu[4].show = true
							break
						// case '07_0002_0004_00':
						// 	this.refundOrderMenu[5].show = true
						}
					}
				}
			})
		},
		// 客户类别
		getCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/list`
			}).then(res => {
				if (res.result === true) {
					this.customList = res.data.childNode
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		sortList (value) {
			this.orderSort = value
			this.findrefundOrderList()
		},
		tableReload () {
			this.findrefundOrderList()
		},
		shopChange () {
			this.findrefundOrderList()
		},
		findShopList () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/findshoplist`
				}).then(res => {
					if (res.result) {
						resolve(res.data.shop)
					} else {
						this.$message.error(res.msg)
					}
				}).catch(err => {
					this.$message.error(err.msg)
				})
			})
		},
		findrefundOrderList () {
			this.tableData = []
			let a = { orderStatus: this.orderStatus, active: this.active, shopId: this.sellerShopId }
			window.sessionStorage.setItem('refundTab', JSON.stringify(a))
			let params = {
				ifBuyer: false,
				beginDate: this.dateValue.length > 0 ? this.dateValue[0] : '',
				endDate: this.dateValue.length > 0 ? this.dateValue[1] : '',
				orderNumber: this.orderNumber,
				refundNumber: this.refundNumber,
				// pushstate: this.pushstate,
				buyerName: this.buyerName,
				buyerTel: this.buyerTel,
				paymentMode: +this.paymentMode,
				payStatus: +this.payStatus,
				liquidateflag: this.liquidateflag,
				cause: this.cause,
				customerCategoryId: this.customerCategoryId,
				customerName: this.customerName,
				autorefundflag: this.autorefundflag,
				address: this.address,
				page: this.page,
				size: this.size,
				sellerShopId: this.sellerShopId,
				orderby: this.orderSort !== '' ? 'billState' : '',
				orderSort: this.orderSort
			}
			if (this.sourcetype !== -1) {
				params.sourcetype = this.sourcetype
			}
			if (this.sourcetype === 22) {
				params.sourcetype = 2
				params.pushstate = 3
			}
			if (this.active !== '全部退单') {
				params.orderStatus = this.orderStatus
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/refundorder/findlist`,
				data: params
			}).then(res => {
				this.totalCount = res.recordCount
				this.clddock = res.clddock
				this.overrefunddock = res.overrefunddock
				if (res.recordList !== null) {
					res.recordList.forEach(item => {
						item.checked = false
						item.orderprice = this.$fxUtils.toFixedSHW(item.orderprice, 2)
						item.sumrefundmoney = this.$fxUtils.toFixedSHW(item.sumrefundmoney, 2)
						switch (item.cause) {
						case 0:
							item.cause = '无理由退换'
							break
						case 1:
							item.cause = '质量问题'
							break
						case 2:
							item.cause = '与商品描述不符合 '
							break
						case 3:
							item.cause = '卖家发错货'
							break
						case 4:
							item.cause = '发票问题'
							break
						case 5:
							item.cause = '其他'
							break
						}
						switch (item.autorefundflag) {
						case 0:
							item.autorefundflag = '手动退单'
							break
						case 1:
							item.autorefundflag = '自动退单'
							break
						}
						switch (item.cancelCause) {
						case 1:
							item.cancelCause = '质量无问题'
							break
						case 2:
							item.cancelCause = '超出退货时间 '
							break
						case 3:
							item.cancelCause = '问题已解决'
							break
						case 4:
							item.cancelCause = '该商品不符合无理由退货'
							break
						case 5:
							item.cancelCause = '影响二次销售'
							break
						case 6:
							item.cancelCause = '其他原因'
							break
						}
						if (item.paymentmode.length === 1) {
							switch (item.paymentmode) {
							case '0':
								item.paymentmode = '线下'
								break
							case '1':
								item.paymentmode = '商龙钱包'
								break
							case '2':
								item.paymentmode = '微信支付'
								break
							case '3':
								item.paymentmode = '支付宝'
								break
							case '4':
								item.paymentmode = '预付货款'
								break
							}
						} else if (item.paymentmode.length > 1) {
							if (item.paymentmode.includes('3')) {
								item.paymentmode = '预付货款、支付宝'
							} else {
								item.paymentmode = '预付货款、商龙钱包'
							}
						}
					})
					this.tableData = res.recordList
				}
			})
		},
		changeName (data) {
			switch (data) {
			case '0':
				this.active = '待处理'
				break
			case '1':
				this.active = '已同意'
				break
			case '2':
				this.active = '已拒绝'
				break
			case '3':
				this.active = '退货完成'
				break
			case '4':
				this.active = '仲裁中'
				break
			default:
				this.active = '全部退单'
				break
			}
		},
		refundOrderMenuSwitch (data) {
			this.orderStatus = data.orderStatus
			this.changeName(this.orderStatus)
			// this.$refs.searchRef.clearInput()
			this.$refs.searchRef.search()
		},
		handleSizeChange (value) {
			this.size = value
			this.page = 1
			// this.$refs.searchRef.clearInput()
			this.findrefundOrderList()
		},
		handlePageChange (value) {
			this.page = value
			// this.$refs.searchRef.clearInput()
			this.findrefundOrderList()
		},
		handleSearch (data) {
			this.dateValue = data.dateValue
			this.buyerTel = data.buyerTel
			this.refundOrderNumber = data.refundOrderNumber
			this.orderNumber = data.orderNumber
			this.paymentMode = data.paymentMode
			this.payStatus = data.payStatus
			this.buyerName = data.buyerName
			this.refundNumber = data.refundNumber
			this.liquidateflag = data.liquidateflag
			this.customerCategoryId = data.customerCategoryId
			this.customerName = data.customerName
			this.sourcetype = data.sourcetype
			this.autorefundflag = data.autorefundflag
			this.address = data.address
			this.orderSort = ''
			this.cause = data.cause
			this.pushstate = data.pushstate
			this.page = 1
			this.excelParams = {
				beginDate: window.sessionStorage.getItem('startDate') ? window.sessionStorage.getItem('startDate') : data.dateValue.length > 0 ? data.dateValue[0] : '',
				endDate: window.sessionStorage.getItem('endDate') ? window.sessionStorage.getItem('endDate') : data.dateValue.length > 0 ? data.dateValue[1] : '',
				orderNumber: data.orderNumber,
				refundNumber: data.refundNumber,
				buyerName: data.buyerName,
				buyerTel: data.buyerTel,
				pushstate: data.pushstate,
				paymentMode: +data.paymentMode,
				payStatus: +data.payStatus,
				cause: data.cause,
				liquidateflag: data.liquidateflag,
				customerCategoryId: data.customerCategoryId,
				customerName: data.customerName,
				sourcetype: data.sourcetype,
				autorefundflag: data.autorefundflag,
				address: data.address
			}
			this.findrefundOrderList()
		},
		// 导出
		exportExcel () {
			const req = new XMLHttpRequest()
			let _this = this
			req.open('POST', `${this.$fxBaseApi.newExportUrl}/refundorder/refundorderList/exportExcel`, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.onload = function () {
				const data = req.response
				const blob = new Blob([data])
				const blobUrl = window.URL.createObjectURL(blob)
				_this.download(blobUrl)
			}
			this.excelParams.ifBuyer = false
			// this.excelParams.isSellerpull = this.isSellerpull
			this.excelParams.sellerShopId = this.sellerShopId
			if (this.active !== '全部退单') {
				this.excelParams.orderStatus = this.orderStatus
			}
			req.send(JSON.stringify(this.excelParams))
		},
		download (blobUrl, num) {
			const a = document.createElement('a')
			a.style.display = 'none'
			var date = new Date()
			var year = date.getFullYear()
			var month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
			var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
			var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
			var min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
			let name = this.active === '全部退单' ? '全部 - 退单详情(' + year + month + day + hour + min + ').xls' : this.active + ' - 退单详情(' + year + month + day + hour + min + ').xls'
			a.download = name
			a.href = blobUrl
			a.click()
		}
	}
}
</script>

<style lang="stylus" scoped>
.refundOrder-body {
	width :100%;
	height:100%;
	min-width :1100px;
	overflow:auto;
	background-color :#ffffff;
	flex: 1
	display flex
	flex-direction column
	.shop-position {
		display flex
		align-items: center
		height: 50px
		font-size: 14px
		border-bottom: 1px solid #dce1fe
		img {
			display inline-block
			width: 20px
			height: 22px
			margin-right: 10px
		}
	}
	.refundOrder-menu {
		height: 50px
		display flex
		border-bottom: 1px solid #dce1fe
		li {
			height: 100%
			line-height: 49px
			margin-right: 55px
			font-size: 14px
			font-weight: 700
			box-sizing:border-box
			cursor: pointer
			position: relative
			&.active {
				color: var(--fx-primary-color)
				border-bottom: 2px solid var(--fx-primary-color)
			}
			span {
				color: #f85050
				position: absolute
				right: -33px
			}
		}
	}
}
</style>
<style lang="stylus">
	.menu-right {
		margin-left: auto;
		height: 100%;
		display: flex;
		align-items: center
		.export-btn {
			span {
				display: flex;
				align-items: center
				div {
					width: 14px;
					height: 14px;
					margin-right: 5px;
					background-image: url('~images/icon/export-icon.png')
				}
			}
			&:hover {
				div {
					background-image: url('~images/icon/export-white-icon.png')
				}
			}
		}
	}
</style>
